import Image from '@tiptap/extension-image'
import { johkuEmbedClass, johkuEmbedDisplaySrc } from '~/lib/tiptap/johkuEmbedImage'

const JohkuImage = Image.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      imageBaseUrl: '',
    }
  },
  addAttributes() {
    const parent = this.parent?.() || {}
    return {
      ...parent,
      src: {
        ...parent.src,
        parseHTML: element => {
          const fileId = element.getAttribute('data-johku-file-id')
          if (fileId && this.options.imageBaseUrl) {
            return johkuEmbedDisplaySrc(this.options.imageBaseUrl, fileId)
          }
          return element.getAttribute('src')
        },
        renderHTML: attributes => {
          if (attributes.fileId && this.options.imageBaseUrl) {
            return { src: johkuEmbedDisplaySrc(this.options.imageBaseUrl, attributes.fileId) }
          }
          if (!attributes.src) {
            return {}
          }
          return { src: attributes.src }
        },
      },
      fileId: {
        default: null,
        parseHTML: element => element.getAttribute('data-johku-file-id'),
        renderHTML: attributes => {
          if (!attributes.fileId) {
            return {}
          }
          return { 'data-johku-file-id': String(attributes.fileId) }
        },
      },
      align: {
        default: null,
        parseHTML: element => {
          return element.getAttribute('data-johku-align')
            || element.className.match(/johku-embed-image--(left|right|center)/)?.[1]
            || null
        },
        renderHTML: attributes => {
          if (!attributes.align) {
            return {}
          }
          return { 'data-johku-align': attributes.align }
        },
      },
      class: {
        default: null,
        parseHTML: element => element.getAttribute('class'),
        renderHTML: attributes => {
          if (!attributes.class) {
            return {}
          }
          return { class: attributes.class }
        },
      },
      // Pasted image whose upload is still running (components/tiptap/Editor.vue).
      // Only kept in the editor, never written to the HTML.
      uploadId: {
        default: null,
        parseHTML: () => null,
        renderHTML: () => ({}),
      },
      size: {
        default: 'm',
        parseHTML: element => {
          return element.getAttribute('data-johku-size')
            || element.className.match(/johku-embed-image--([sml])(?:\s|$)/)?.[1]
            || 'm'
        },
        renderHTML: attributes => {
          if (!attributes.size) {
            return {}
          }
          return { 'data-johku-size': attributes.size }
        },
      },
    }
  },
})

export function johkuImageAttrs(file: { id: string | number, title?: string }, src: string, align: string, size = 'm') {
  return {
    src,
    alt: file.title || '',
    title: file.title || '',
    fileId: String(file.id),
    align,
    size,
    class: johkuEmbedClass(align, size),
  }
}

export default JohkuImage
